import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import {
  CheckCircle as PaidIcon,
  ErrorOutline as UnpaidIcon,
  Undo as RefundedIcon,
} from '@mui/icons-material';

/**
 * Paid / unpaid badge for a job, from the backend's effective `paymentState`
 * (PAID | UNPAID | REFUNDED | NOT_DUE — see services/jobPaymentState.js).
 * Unpaid jobs whose date has passed are flagged as past due.
 */
const PaymentStateChip = ({ state, scheduledDate, size = 'small' }) => {
  if (!state || state === 'NOT_DUE') return null;

  if (state === 'PAID') {
    return <Chip icon={<PaidIcon />} label="Paid" color="success" size={size} variant="outlined" />;
  }
  if (state === 'REFUNDED') {
    return <Chip icon={<RefundedIcon />} label="Refunded" size={size} variant="outlined" />;
  }

  const pastDue = scheduledDate && new Date(scheduledDate).getTime() < Date.now();
  return (
    <Tooltip title={pastDue ? 'The visit date has passed and no payment is recorded' : 'Not paid yet'}>
      <Chip
        icon={<UnpaidIcon />}
        label={pastDue ? 'Unpaid · past due' : 'Unpaid'}
        color={pastDue ? 'error' : 'warning'}
        size={size}
        variant={pastDue ? 'filled' : 'outlined'}
      />
    </Tooltip>
  );
};

export default PaymentStateChip;
